import React, { useEffect, useState } from "react";
import { CodeVerification } from "../ui/Form/CodeVerification";
import PropTypes from "prop-types";
import Icon from "../Icon";
import _Button from "../generic/_Button";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { ErrorMessage, SuccessMessage } from "../../utils/toastify";
import { Spinner } from "react-bootstrap";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
const Verify2fa = ({ formik, isLoading = false, onAction }) => {
  const [countTime, setCountTime] = useState(30);
  const [reset, setReset] = useState(false);
  const [loading, setLoading] = useState(false);

  const { mutate: resend2fa } = useMutation({
    mutationKey: ["resend2fa"],
    mutationFn: async (values) => {
      const response = await axios.post(`${ApiEndpoint}users/resend`, {
        uuid: values.uuid,
      });
      return response.data;
    },
    onSuccess: ({ attempts }) => {
      if (attempts >= 3) {
        formik.resetForm();
        setReset(true);
        formik.setFieldError("code", "El codigo ha sido bloqueado");
        ErrorMessage("El codigo ha sido bloqueado");
        return;
      }

      SuccessMessage("El código ha sido enviado");
      setReset(true);
      setCountTime(30);
    },
    onError: (error) => {
      console.error(error);
      ErrorMessage("Error al enviar el código");
    },
  });

  useEffect(() => {
    if (countTime <= 0) return;

    const interval = setInterval(() => {
      setCountTime((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
      setReset(false);
    };
  }, [countTime, reset]);

  useEffect(() => {
    if (formik.values.code.length === 6) {
      setLoading(true);
      setTimeout(() => {
        onAction({
          uuid: formik.values.uuid,
          code: formik.values.code,
        });
        setLoading(false);
      }, 500);
    }
  }, [formik.values.code]);

  return (
    <div className="bg-white rounded-lg px-4 py-4 w-full max-w-[300px] lg:max-w-[500px]">
      <h2 className="text-2xl font-bold text-gray-600"> Verificar Código </h2>

      <div className="flex items-center gap-2 justify-center bg-blue-200 px-4 py-2 rounded-lg my-2">
        <Icon icon="info" className={"text-blue-800"} />
        <span>
          Se ha enviado un mensaje de verificación al medio de mensaje
          previamente registrado
        </span>
      </div>

      <div className="flex flex-col items-center p-5 justify-center ">
        <CodeVerification
          value={formik.values.code}
          onChange={(value) => formik.setFieldValue("code", value)}
          reset={reset}
          error={formik.values.error_code}
          disabled={isLoading || loading}
        />
        {loading && (
          <>
            <Spinner animation="border" role="status" />{" "}
            <span>Verificando...</span>
          </>
        )}
      </div>
      <div className="flex justify-center my-2">
        <_Button
          style="none"
          icon="refresh"
          title={`Reenviar código ${
            countTime > 0 ? `en ${countTime} segundos` : "ahora"
          }`}
          onClick={() => {
            resend2fa({ uuid: formik.values.uuid });
          }}
          disabled={countTime > 0 || isLoading || loading}
        />
      </div>
    </div>
  );
};

Verify2fa.propTypes = {
  formik: PropTypes.object,
  isLoading: PropTypes.bool,
  onAction: PropTypes.func,
  resend2fa: PropTypes.func,
};

export default Verify2fa;
